import { IonIcon } from '@ionic/react';
import { Tooltip } from 'antd';
import i18next from 'i18next';
import { informationCircle } from 'ionicons/icons';

interface Props {
  value: string;
  className?: string;
}

export const TooltipInInput = ({ value, className = 'b-tooltip' }: Props) => {
  return (
    <div className={className}>
      <Tooltip title={i18next.t('TOOLTIPS.' + value)}>
        <IonIcon icon={informationCircle} color="dark" style={{ fontSize: 24 }}></IonIcon>
      </Tooltip>
    </div>
  );
};
